import React from 'react';
import Search from './Search'

class SearchUser extends Search {

  componentWillMount() {
    if (!sessionStorage.getItem('auth')) {
      browserHistory.push('/')
    }

    this.performSearch(this.props.location.query);
  }

}

export default SearchUser;



// WEBPACK FOOTER //
// ./src/components/SearchUser.js